import { Component, input, signal, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LTPrimeNgModule } from 'src/app/third-party/lt-primeng.module';
import { ExportOptions } from 'src/app/features/grid/services/papa-parse-export-service.service';
import { MatCardModule } from '@angular/material/card';
@Component({
  selector: 'app-lt-export-config',
  imports: [
    CommonModule,
    FormsModule,
    LTPrimeNgModule,
    MatCardModule,
  ],
  standalone: true,
  templateUrl: './lt-export-config.component.html',
  styleUrl: './lt-export-config.component.scss',
})
export class LtExportConfigComponent {
  exportOptions = input.required<ExportOptions>();
  showAdvanced = input<boolean>(false);
  optionsChange = output<Partial<ExportOptions>>();

  nestedSeparator = signal<string>(' - ');
  flattenHeaders = signal<boolean>(true);
  separatorRow = signal<boolean>(true);
  totalLabel = signal<string>('Total');
  averageLabel = signal<string>('Average');
  countLabel = signal<string>('Count');

  onConfigChange(): void {
    this.optionsChange.emit({
      nestedColumnSeparator: this.nestedSeparator(),
      flattenNestedHeaders: this.flattenHeaders(),
      aggregateSeparatorRow: this.separatorRow(),
    });
  }

  onLabelChange(type: string, value: string): void {
    const customLabels = { ...this.exportOptions().customAggregateLabels };
    customLabels[type] = value;
    this.optionsChange.emit({ customAggregateLabels: customLabels });
  }
}
